export const emptyValue = '-';

export const applicationStatuses = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
} as const;

export const applicationStages = {
  Applied: 'Applied',
  Evaluating: 'Evaluating',
  Qualified: 'Qualified',
  Offer: 'Offer',
  Rejected: 'Rejected',
  Withdrawn: 'Withdrawn',
  Closed: 'Closed',
} as const;

export const DECISION_LABELS = {
  INTAKE: 'Intake',
  REJECT: 'Reject',
  WITHDRAWAL: 'Register withdrawal',
} as const;

export type Decision = keyof typeof DECISION_LABELS;

export const SCHEDULE_MODES = {
  SELF_BOOKING: 'SELF_BOOKING',
  SELF_BOOKING_SELECTED: 'SELF_BOOKING_SELECTED',
  MANUAL: 'MANUAL',
} as const;

export type ScheduleMode = (typeof SCHEDULE_MODES)[keyof typeof SCHEDULE_MODES];

export const REJECTION_REASONS = {
  NOT_ENOUGH_EXPERIENCE: 'Not enough experience',
  SALARY_EXPECTATIONS: 'Salary expectations',
  FAILED_SCREENING: 'Failed screening',
  POSITION_CLOSED: 'Position closed',
  NO_RESPONSE: 'No response from the candidate',
};
